import H5Image from 'web-materials/dist/esm/components/common/H5Image';

export default function Img(props) {
  const BASE_URL = 'https://cdn.duetapp.net/v1/images/';
  if (!props?.src?.includes(BASE_URL)) {
    return <H5Image {...props} type="origin" src={`${BASE_URL}${props?.src}`} />;
  }
  return <H5Image {...props} type="origin" src={props?.src} />;
}
